// extracted by mini-css-extract-plugin
export default {"captchaWrap":"Style_captchaWrap__DOUNj","loginAction":"Style_loginAction__+5eI4"};